import { EventBus } from '@/EventBus';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
let communities;

export async function initGeocoder(map) {
    communities = (await axios.get('communities.geojson')).data;
    const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl,
        countries: 'AU',
        bbox: [
            117.58863683065857,
            -20.35388700617372,
            129.14678971758326,
            -13.657869582002988,
        ],
        localGeocoder: searchCommunities,
    });
    window.g = geocoder;
    document
        .getElementById('geocoder-container')
        .appendChild(geocoder.onAdd(map));
    const resultPopup = new mapboxgl.Popup({
        closeOnClick: false,
    });
    geocoder.on('result', (e) => {
        EventBus.$emit('geocoder-result', e);
        console.log(e);
        resultPopup
            .setLngLat(e.result.center)
            .setHTML(e.result.place_name.replace(/, Western Australia.*/, ''))
            .addTo(map);
    });
    geocoder.on('clear', (e) => {
        EventBus.$emit('geocoder-clear', e);
    });
}
function searchCommunities(queryString) {
    const startsWith = (a, b) =>
        String(a)
            .toLowerCase()
            .startsWith(b.toLowerCase());
    const includes = (a, b) =>
        String(a)
            .toLowerCase()
            .includes(b.toLowerCase());

    function getScore(community) {
        let score = 0;
        if (startsWith(community.properties.common_name, queryString)) {
            score += 5;
        } else if (includes(community.properties.common_name, queryString)) {
            score += 1;
        }

        const otherNames = (community.properties.other_names || '').split(', ');
        if (otherNames.find((n) => startsWith(n, queryString))) {
            score += 5;
        } else if (otherNames.find((n) => includes(n, queryString))) {
            score += 1;
        }
        return score;
    }
    return communities.features
        .map((community) => {
            const name =
                community.properties.common_name +
                (community.properties.other_names
                    ? ` (${community.properties.other_names})`
                    : '');
            return {
                ...community,
                text: name,
                place_name: name,
                place_type: 'place',
                center: community.geometry.coordinates,
                properties: {
                    ...community.properties,
                    score: getScore(community),
                },
            };
        })
        .filter((c) => c.properties.score > 0)
        .sort((a, b) => b.properties.score - a.properties.score);
}
